module.exports = __webpack_public_path__ + "static/media/4.071ff343.jpg";